import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import {reduxBatch} from '@manaflair/redux-batch';
import set from 'lodash/fp/set';
import {createLogger} from 'redux-logger';
import chatReducer from './reducers/chat';
import collectReducer from './reducers/collect';
import connectionsReducer from './reducers/connections';
import eventsReducer from './reducers/eventsCommon';
import formsReducer from './reducers/forms';
import i18nReducer from './reducers/i18n';
import notificationsReducer from './reducers/notifications';
import onlineUsersReducer from './reducers/onlineUsers';
import pushNotificationsReducer from './reducers/pushNotifications';
import sessionReducer from './reducers/session';
import uiReducer from './reducers/ui';
import usersReducer from './reducers/users';
import onceReducer from './reducers/once';

const combinedReducers = combineReducers({
    i18n: i18nReducer,
    session: sessionReducer,
    events: eventsReducer,
    ui: uiReducer,
    notifications: notificationsReducer,
    pushNotifications: pushNotificationsReducer,
    chat: chatReducer,
    users: usersReducer,
    forms: formsReducer,
    connections: connectionsReducer,
    onlineUsers: onlineUsersReducer,
    collect: collectReducer,
    once: onceReducer,
});

const topLevelReducer = function (state, action) {
    switch (action.type) {
        case 'SET':
            return set(action.key, action.value, state);
        case 'RESTORE_SAVED_STATE':
            return combinedReducers(action.state, action);
        default:
            return combinedReducers(state, action);
    }
};

const SKIP_LOG_ACTIONS = ['UI_LOADER_START', 'UI_LOADER_STOP', 'UI_FREE', 'UI_BUSY'];

// __ENABLE_LOGS__ defined on webpack config
const logsConfig = {enabled: __ENABLE_LOGS__},
    logger = createLogger({
        predicate: (getState, action) => logsConfig.enabled && !SKIP_LOG_ACTIONS.includes(action.type),
        collapsed: (getState, action, logEntry) => !logEntry.error,
        titleFormatter: (action, time, took) => `webapp action ${action.type}`,
    });

const store = createStore(topLevelReducer, compose(reduxBatch, applyMiddleware(logger), reduxBatch));
store.logsConfig = logsConfig;
export default store;

import observeExtension from '../misc/storeObserver.mixin';
observeExtension(store);
